/**
 * 跟踪数据的相关方法
 *
 */

/**
 * 获取客户端的基本信息
 * @param {} dataurl
 */
export const getClientBaseData = () => {
  // 基础数据
  const base = {}
  // Document对象数据
  if (document) {
    base.domain = document.domain || ''
    base.url = document.URL || ''
    base.title = document.title || ''
    base.referrer = document.referrer || ''
  }
  // Window对象数据
  if (window && window.screen) {
    base.sh = window.screen.height || 0
    base.sw = window.screen.width || 0
    base.cd = window.screen.colorDepth || 0
  }
  // navigator对象数据
  if (navigator) {
    base.lang = navigator.language || ''
  }
  return base
}
